import styled from 'styled-components'

export const PetsDisclaimerPanel = styled.div(
  ({ theme }) => `
  background-color: ${theme.colors.grey.light5};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.default};
`
)
